import {Injectable} from '@angular/core';
import {MyDialogDataModel} from '../models/my-dialog-data.model';
import {ProductModel} from '../models/product.model';
import {HardwareTonerColorInfoEnum} from '../enums/hardware-toner-color-info.enum';
import {MyNotDeviceRequestContainerModel} from '../models/my-not-device-request-container.model';
import {EnumUtils} from '../utils/enum.utils';
import {RPriceIdentifierEnum} from '../enums/r-price-identifier.enum';
import {MyDeviceRequestContainerModel} from '../models/my-device-request-container.model';
import {RequestedNotDeviceItemModel} from '../models/requested-not-device-item.model';
import {PriceInfoModel} from '../models/price-info.model';
import {MyPageRPricesSelectBase} from '../enums/my-page-rprices-select-base.enum';
import {CustomPriceInfoModel} from '../models/custom-price-info.model';
import {ProjectModel} from '../models/project.model';
import {ParentSkuMappingItemModel} from '../models/parent-sku-mapping-item.model';
import {MyProductRPricesSelectBaseEnum} from '../enums/my-product-rprices-select-base.enum';
import {RequestedDeviceItemModel} from '../models/requested-device-item.model';
import {MyProductAmountModel} from '../models/my-product-amount.model';
import {TonerTypeEnum} from '../enums/toner-type.enum';
import {SupplyAcquisitionTypeEnum} from '../enums/supply-acquisition-type.enum';

@Injectable()
export class ContainerUtilsService {

    private _dialogModel: MyDialogDataModel;

    constructor() {
    }

    public initDialogModel(dialogModel: MyDialogDataModel) {
        this._dialogModel = dialogModel;
    }

    get dialogModel(): MyDialogDataModel {
        if (!this._dialogModel) {
            console.error('ContainerUtilsService dialogModel connection is not initialized yet');
        }
        return this._dialogModel;
    }


    public isColorPrinter(printer: ProductModel): boolean {

        return printer.hardwareColorTonerInfo === undefined || printer.hardwareColorTonerInfo === HardwareTonerColorInfoEnum[HardwareTonerColorInfoEnum.COLOR];
    }

    public setRecommendedSupplyPrice(supplyContainer: MyNotDeviceRequestContainerModel) {
        const itemNameBegin = supplyContainer.itemToOrder.sku.slice(0, 2);
        const drTnType = itemNameBegin === 'DR' || itemNameBegin === 'TN';

        supplyContainer.notDeviceRequest.priceInfo.selectedPrice =
            EnumUtils.getKeyByValue(RPriceIdentifierEnum, drTnType ? RPriceIdentifierEnum.R5 : RPriceIdentifierEnum.R2);

        if (!supplyContainer.notDeviceRequest.priceInfo.rPriceInfo.some(priceInfo =>
            priceInfo.rPriceIdentifier === supplyContainer.notDeviceRequest.priceInfo.selectedPrice)) {
            console.error(supplyContainer.itemToOrder.sku +
                ' - selected price was set to requested value, but the possible choices for this supply do not contains this value (rest data are not consistent), so the value will not be visible on screen',
                supplyContainer.notDeviceRequest.priceInfo);
        }
    }

    public setRecommendedDevicePagePrice(deviceContainer: MyDeviceRequestContainerModel, priceIdToSetTo: RPriceIdentifierEnum) {

        if (this.isColorPrinter(deviceContainer.itemToOrder)) {
            deviceContainer.devicePricePerPage.color.selectedPrice = EnumUtils.getKeyByValue(RPriceIdentifierEnum, priceIdToSetTo);
            if (!deviceContainer.devicePricePerPage.color.rPriceInfo.some(priceInfo =>
                priceInfo.rPriceIdentifier === deviceContainer.devicePricePerPage.color.selectedPrice)) {
                console.error(deviceContainer.itemToOrder.sku +
                    ' - selected color page price was set to requested value, but the possible choices for this device do not contains this value (rest data are not consistent), so the value will not be visible on screen',
                    deviceContainer.devicePricePerPage.color);
            }
        }


        deviceContainer.devicePricePerPage.mono.selectedPrice = EnumUtils.getKeyByValue(RPriceIdentifierEnum, priceIdToSetTo);
        if (!deviceContainer.devicePricePerPage.mono.rPriceInfo.some(priceInfo =>
            priceInfo.rPriceIdentifier === deviceContainer.devicePricePerPage.mono.selectedPrice)) {
            console.error(deviceContainer.itemToOrder.sku +
                ' - selected monochrome page price was set to requested value, but the possible choices for this device do not contains this value (rest data are not consistent), so the value will not be visible on screen',
                deviceContainer.devicePricePerPage.mono);
        }
    }


    /**
     * set recommended RPrice to device accessory or warranty
     * @param dAWContainer
     */
    public setRecommendedDAWPrice(dAWContainer: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel) {

        const request = (dAWContainer as MyDeviceRequestContainerModel).deviceRequest || (dAWContainer as MyNotDeviceRequestContainerModel).notDeviceRequest;

        request.priceInfo.selectedPrice = EnumUtils.getKeyByValue(RPriceIdentifierEnum, RPriceIdentifierEnum.R5);
        if (!request.priceInfo.rPriceInfo.some(priceInfo =>
            priceInfo.rPriceIdentifier === request.priceInfo.selectedPrice)) {
            console.error(dAWContainer.itemToOrder.sku +
                ' - selected price was set to requested value, but the possible choices for this device do not contains this value (rest data are not consistent), so the value will not be visible on screen',
                request.priceInfo);
        }
    }

    public addPrintSmartContainerPagePricesToRequestedSupplies(deviceContainer: MyDeviceRequestContainerModel) {
        // const projectSuppliesRequests = this.dialogModel.project.requestedSupplyInfo.requestedSupplies;

        const supplyRequest = new RequestedNotDeviceItemModel();
        let sharedComment: string;

        // @ts-ignore
        supplyRequest.pricePerPage = {...deviceContainer.devicePricePerPage};
        if (supplyRequest.pricePerPage.mono) {
            if (supplyRequest.pricePerPage.mono.selectedPrice) {
                // mono and color note are using the color customPriceInfo note toghether
                // comment = supplyRequest.pricePerPage.mono.customPriceInfo && supplyRequest.pricePerPage.mono.customPriceInfo.customPriceComment ?
                //     supplyRequest.pricePerPage.mono.customPriceInfo.customPriceComment : undefined;

                supplyRequest.pricePerPage.mono = {...supplyRequest.pricePerPage.mono};
                delete supplyRequest.pricePerPage.mono.rPriceInfo;
            } else {

                delete supplyRequest.pricePerPage.mono;
            }
        }
        if (supplyRequest.pricePerPage.color) {
            if (supplyRequest.pricePerPage.color.selectedPrice) {
                // const colorComment = supplyRequest.pricePerPage.color.customPriceInfo && supplyRequest.pricePerPage.color.customPriceInfo.customPriceComment ?
                //     supplyRequest.pricePerPage.color.customPriceInfo.customPriceComment : undefined;
                // if (comment && colorComment) {
                //     comment = comment + ', ' + colorComment;
                // } else {
                //     comment = comment ? comment : colorComment;
                // }

                sharedComment = supplyRequest.pricePerPage.color.customPriceInfo && supplyRequest.pricePerPage.color.customPriceInfo.customPriceComment ?
                    supplyRequest.pricePerPage.color.customPriceInfo.customPriceComment : undefined;

                supplyRequest.pricePerPage.color = {...supplyRequest.pricePerPage.color};
                delete supplyRequest.pricePerPage.color.rPriceInfo;
            } else {

                delete supplyRequest.pricePerPage.color;
            }
        }

        // comment = (comment !== '') ? comment : undefined;

        this.setCustomPagePriceComment(supplyRequest.pricePerPage.mono, sharedComment);
        this.setCustomPagePriceComment(supplyRequest.pricePerPage.color, sharedComment);


        supplyRequest.sku = deviceContainer.itemToOrder.sku;
        this.dialogModel.project.requestedSupplyInfo.requestedSupplies.push(supplyRequest);
    }

    private setCustomPagePriceComment(priceInfo: PriceInfoModel, comment: string): void {
        if (priceInfo) {
            if (MyPageRPricesSelectBase[priceInfo.selectedPrice] === MyPageRPricesSelectBase.CUSTOM) {
                priceInfo.customPriceInfo = priceInfo.customPriceInfo ?
                    priceInfo.customPriceInfo : new CustomPriceInfoModel();
                priceInfo.customPriceInfo.customPriceComment = comment;
            } else {
                delete priceInfo.customPriceInfo;
            }
        }
    }

    public addSupplyContainerToRequestedSupplies(supplyContainer: MyNotDeviceRequestContainerModel, hasParentDeviceProcessingType = true) {

        // console.log('addSupplyContainerToRequestedSupplies', supplyContainer);


        const projectSuppliesRequests = this.dialogModel.project.requestedSupplyInfo.requestedSupplies;
        let supplyAmount = 0;
        if (ProjectModel.isPrintSmartSupplyAcquisitionType(this.dialogModel.project)) {
            if (!supplyContainer.parentPrintSmartDedicatedSupplyAmount) {
                console.log('parent sku', supplyContainer.parent.itemToOrder.sku);
                console.log('supply sku', supplyContainer.itemToOrder.sku);

                console.error('parentPrintSmartDedicatedSupplyAmount is not defined but for the MPS_BASED_ON_UNIT_COUNT must be deffined project.supplyAcquisitionType: ',
                    this.dialogModel.project.supplyAcquisitionType);
            }
            supplyAmount = supplyContainer.parentPrintSmartDedicatedSupplyAmount.amount;
        } else {
            supplyAmount = hasParentDeviceProcessingType ? supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount
                : supplyContainer.noParentGeneralSupplyAmount.amount;
        }

        // check if supply is already in output array
        // by new spec, there can be one item two time in output array, once without parentSkuMapping for supplies without parent device
        // and once with parentSkuMapping for items connected with some parent device, so we have distinguish it  by the parent processing type

        let supplyRequest: RequestedNotDeviceItemModel = null;
        if (hasParentDeviceProcessingType) {
            supplyRequest = <RequestedNotDeviceItemModel>projectSuppliesRequests.find(requestedSupplyItem => {
                return (requestedSupplyItem.sku === supplyContainer.itemToOrder.sku  // there can be also used the supplyContainer.notDeviceRequest.sku
                    && requestedSupplyItem?.parentSkuMapping.length > 0);
            });
        } else {
            supplyRequest = <RequestedNotDeviceItemModel>projectSuppliesRequests.find(requestedSupplyItem => {
                return (requestedSupplyItem.sku === supplyContainer.notDeviceRequest.sku // there can be also used the supplyContainer.notDeviceRequest.sku
                    && (!requestedSupplyItem.parentSkuMapping || requestedSupplyItem.parentSkuMapping.length === 0));
            });
        }


        if (supplyRequest) {
            // supply with this sku already exist in requestedSupplies, so update its parentSkuMapping
            // tslint:disable-next-line:max-line-length

            if (hasParentDeviceProcessingType) {
                const parentSku = supplyContainer.parent.itemToOrder.sku;
                if (supplyRequest.parentSkuMapping) {
                    const currentProductSkuMapping = supplyRequest.parentSkuMapping.find(
                        parentSkuMappingItem => parentSkuMappingItem.sku === parentSku);
                    if (currentProductSkuMapping) {
                        // mapping to parent device already exist, add amount
                        currentProductSkuMapping.amount += supplyAmount;
                    } else {
                        // mapping to parent device not exist yet, add it
                        const newParentSkuMapping = new ParentSkuMappingItemModel();
                        newParentSkuMapping.amount = supplyAmount;
                        newParentSkuMapping.sku = parentSku;
                        supplyRequest.parentSkuMapping.push(newParentSkuMapping);
                    }
                }
            } else {  // NOT hasParentDevice
                if (supplyRequest.parentSkuMapping) {
                    console.error(' parentSkuMapping already exist for product processed as noParentDevice kind, ' +
                        'parentSkuMapping will be deleted:', supplyRequest);
                    delete supplyRequest.parentSkuMapping;
                }
            }
            // update sum of all (parentSkuMapping) amounts
            supplyRequest.amount += supplyAmount;

        } else {
            // supply is not in order array yet
            // console.log('going to crete new request from supplyContainer', supplyContainer);
            supplyRequest = Object.assign(RequestedNotDeviceItemModel.getNewInstance(), supplyContainer.notDeviceRequest);
            // delete supplyRequest.priceInfo.rPriceInfo;
            supplyRequest.priceInfo = {...supplyRequest.priceInfo};

            // supplyRequest.priceInfo.rPriceInfo = null;
            delete supplyRequest.priceInfo.rPriceInfo;

            // is selectedPrice === 'CUSTOM' then customPriceInfo model should be defined
            if (supplyRequest.priceInfo && supplyRequest.priceInfo.selectedPrice) {
                if (MyProductRPricesSelectBaseEnum[supplyRequest.priceInfo.selectedPrice] !== MyProductRPricesSelectBaseEnum.CUSTOM) {
                    delete supplyRequest.priceInfo.customPriceInfo;
                }
            } else {
                // selectedPrice is undefined
                delete supplyRequest.priceInfo.customPriceInfo;
            }


            if (hasParentDeviceProcessingType) {
                supplyRequest.parentSkuMapping = [];
                const newParentSkuMapping = new ParentSkuMappingItemModel();
                newParentSkuMapping.amount = supplyAmount;
                // tslint:disable-next-line:max-line-length
                newParentSkuMapping.sku = supplyContainer.parent ? supplyContainer.parent.itemToOrder.sku : null;  // can be null if supply has no parent
                supplyRequest.parentSkuMapping.push(newParentSkuMapping);
            }

            // update sum of all parentSkuMapping amounts, currently there is only one
            supplyRequest.amount = supplyAmount;
            supplyRequest.sku = supplyContainer.itemToOrder.sku;

            projectSuppliesRequests.push(supplyRequest);
            // console.log('- new requestedSupply added  - hasParentDevice status:' + hasParentDeviceProcessingType, supplyRequest);
        }
    }

    /**
     * converts warranty or accessory container data to the rest project requested product
     * @param notDeviceContainer
     * @param projectsRequestedProducts
     */
    public addWarrantyOrAccessoryContainerToRESTRequestedProducts(notDeviceContainer: MyNotDeviceRequestContainerModel,
                                                                  projectsRequestedProducts: (RequestedDeviceItemModel | RequestedNotDeviceItemModel) []) {

        const requestedProductSku = notDeviceContainer.itemToOrder.sku;
        const requestedProductAmount = notDeviceContainer.waAcLsAmount.amount;

        // check if projectRequestedProduct already contains item with requestedProductSku
        const projectRequestedProduct = <RequestedNotDeviceItemModel>projectsRequestedProducts.find(
            rp => rp.sku === requestedProductSku);

        if (projectRequestedProduct) {
            projectRequestedProduct.amount = requestedProductAmount;
        } else {
            // if requestedItemProduct not found, create new with new parentSkuMapping
            const newProjectRequestedProduct = RequestedNotDeviceItemModel.getNewInstance({...notDeviceContainer.notDeviceRequest.priceInfo});
            delete newProjectRequestedProduct.priceInfo.rPriceInfo;

            newProjectRequestedProduct.sku = requestedProductSku;
            newProjectRequestedProduct.amount = requestedProductAmount;
            projectsRequestedProducts.push(newProjectRequestedProduct);
        }
    }

    /**
     * supplyContainer notDeviceRequest must be shared for all containers arrays
     * this function will connect supplyContainer.notDeviceRequest to shared availableSuppliesContainer.notDeviceRequest dedicated for same item
     * @param supplyContainer
     * @param enableTest
     */
    public initSupplyContainers_SupplyRequest(supplyContainer: MyNotDeviceRequestContainerModel, enableTest: boolean = false) {

        if (supplyContainer.notDeviceRequest && enableTest) {
            // testing part developing purposes only
            const basedSupplyContainer = this.dialogModel.availableSuppliesContainers.find(sc => sc.itemToOrder.sku === supplyContainer.itemToOrder.sku);
            const testNumber = Math.random();
            basedSupplyContainer.notDeviceRequest.connectionTest = testNumber;
            if (supplyContainer.notDeviceRequest.connectionTest !== testNumber) {
                console.error('initSupplyContainers_SupplyRequest - supply container connection lost');
            }
            // else {
            //     console.log('supply container connection to based checked');
            // }
            return;
        } else {

            // console.log('initSupplyContainers_SupplyRequest');

            const availableSupplyContainer = this.dialogModel.availableSuppliesContainers.find(sc => sc.itemToOrder.sku === supplyContainer.itemToOrder.sku);
            if (availableSupplyContainer) {
                if (!availableSupplyContainer.notDeviceRequest) {
                    availableSupplyContainer.notDeviceRequest = RequestedNotDeviceItemModel.getNewInstance(PriceInfoModel.getNewInstance((availableSupplyContainer.itemToOrder).rPrices)); // this is only place where the notDivceReques for supply container can be set to new value
                }
                supplyContainer.notDeviceRequest = availableSupplyContainer.notDeviceRequest;  // this is only place where the notDivceReques for supply container can be set to new object
            } else {
                console.error('baseSupply container not found for given supplyContainer  ', supplyContainer);
            }
            // console.log('baseSupplyContainer notDeviceRequest loaded', supplyContainer.notDeviceRequest);
        }
    }

    public calculateMPSSuppliesAmount(supplyContainer: MyNotDeviceRequestContainerModel, project: ProjectModel) {
        if (!supplyContainer.parentPrintSmartDedicatedSupplyAmount) {
            supplyContainer.parentPrintSmartDedicatedSupplyAmount = new MyProductAmountModel();
        }
        supplyContainer.parentPrintSmartDedicatedSupplyAmount.amount = this.getRecommendedSupplyAmount(supplyContainer, project);
    }

    public getRecommendedSupplyAmount(supplyContainer: MyNotDeviceRequestContainerModel, project: ProjectModel): number {
        // speed can be increased by adding recommended supply amount to the supply container which could eliminate too often usage/repeating
        // especially for showAmountWarning functionality
        const debugLevel = 0;  // PPU_log
        try {

            const tonerType = TonerTypeEnum[supplyContainer.itemToOrder.tonerInfo.tonerType];

            let printVolume = 0;

            if (tonerType) {
                if (tonerType === TonerTypeEnum.MONO) {
                    printVolume = supplyContainer.parent.deviceRequest.metaData.monoPageCountPerMonth;
                } else if (tonerType === TonerTypeEnum.COLOR) {
                    printVolume = supplyContainer.parent.deviceRequest.metaData.colorPageCountPerMonth;
                }

                if (!Number.isFinite(printVolume) || printVolume === 0) {
                    if (debugLevel) {
                        console.log('printVolume is not defined - supplyContainer.parent.deviceRequest for tonerType:' + tonerType + ':', supplyContainer.parent.deviceRequest);
                        return -1;
                    }
                    return null;
                }
            } else {
                // console.warn('tonerType is not defined for sku' + supplyContainer.itemToOrder.sku + ', tonerType = ' + TonerTypeEnum[tonerType], supplyContainer.itemToOrder);
                return null;
            }


            let timePeriodInMonths = 0;


            if (SupplyAcquisitionTypeEnum[project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT) {
                timePeriodInMonths = project.requestedSupplyInfo.timePeriodInMonths && +project.requestedSupplyInfo.timePeriodInMonths;
            } else if (SupplyAcquisitionTypeEnum[project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.PURCHASE) {

                if (project.requestedSupplyInfo && project.requestedSupplyInfo.rolloutStart && project.requestedSupplyInfo.rolloutEnd) {
                    timePeriodInMonths = (project.requestedSupplyInfo.rolloutEnd.getTime() - project.requestedSupplyInfo.rolloutStart.getTime()) / 1000 / 60 / 60 / 24 / 30;
                    if (timePeriodInMonths < 0) {
                        timePeriodInMonths = 0;
                    }
                    timePeriodInMonths = Math.ceil(timePeriodInMonths);
                    if (debugLevel > 5) {
                        console.log('calculate timePeriodInMonths: ', timePeriodInMonths);
                    }
                } else {
                    if (debugLevel) {
                        console.log(supplyContainer.itemToOrder.sku + ' - some of supply info dates is not defined yet (rolloutStart/rolloutEnd): '
                            + project.requestedSupplyInfo.rolloutStart + '/' + project.requestedSupplyInfo.rolloutEnd);
                    }
                    return null;
                }

            }

            if (!Number.isFinite(timePeriodInMonths)) {
                if (debugLevel) {
                    console.log('timePeriodInMonths is not defined yet for  project.supplyAcquisitionType' + project.supplyAcquisitionType, timePeriodInMonths);
                }
                return null;
            }

            if (timePeriodInMonths < 1) {
                if (debugLevel) {
                    console.log('timePeriodInMonths is to low for project.supplyAcquisitionType ' + project.supplyAcquisitionType, timePeriodInMonths);
                    return -4;
                }
                return null;
            }
            const supplyRange = supplyContainer.itemToOrder.tonerInfo.range;


            if (!Number.isFinite(supplyRange) || supplyRange === 0) {
                // console.warn('supply range is not defined or supplyRange = 0, amount cannot be calculated for sku:' + supplyContainer.itemToOrder.sku, supplyContainer);
                return 0;
            }
            const supplyRangeStarter = supplyContainer.itemToOrder.tonerInfo.rangeStarter;
            const hardwareCount = supplyContainer.parent.deviceAmount.amount;


            if ((printVolume * timePeriodInMonths) < supplyRangeStarter) {
                if (debugLevel) {
                    console.log(supplyContainer.parent.itemToOrder.sku + ' / ' + supplyContainer.itemToOrder.sku + ' - supplyRangeStarter enough to cover full required time period');
                }
                return 0;
            }

            // console.log(timePeriodInMonths);

            return Math.ceil((((printVolume * timePeriodInMonths) - supplyRangeStarter) / supplyRange) * hardwareCount);
        } catch (e) {
            console.warn('error occurred during recommended supply amount calculation: ', e.message);
            return 0;
        }
    }

    // public getRecommendedSupplyAmount(supplyContainer: MyNotDeviceRequestContainerModel, project: ProjectModel): number {
    //     // speed can be increased by adding recommended supply amount to the supply container which could eliminate too often usage/repeating
    //     // especially for showAmountWarning functionality
    //     const debugLevel = 0;  // PPU_log
    //     try {

    //         const tonerType = TonerTypeEnum[supplyContainer.itemToOrder.tonerInfo.tonerType];

    //         let printVolume = 0;

    //         if (tonerType) {
    //             if (tonerType === TonerTypeEnum.MONO) {
    //                 printVolume = supplyContainer.parent.deviceRequest.metaData.monoPageCountPerMonth;
    //             } else if (tonerType === TonerTypeEnum.COLOR) {
    //                 printVolume = supplyContainer.parent.deviceRequest.metaData.colorPageCountPerMonth;
    //             }

    //             if (!Number.isFinite(printVolume) || printVolume === 0) {
    //                 if (debugLevel) {
    //                     console.log('printVolume is not defined - supplyContainer.parent.deviceRequest for tonerType:' + tonerType + ':', supplyContainer.parent.deviceRequest);
    //                     return -1;
    //                 }
    //                 return null;
    //             }
    //         } else {
    //             console.warn('tonerType is not defined for sku' + supplyContainer.itemToOrder.sku + ', tonerType = ' + TonerTypeEnum[tonerType], supplyContainer.itemToOrder);
    //             return null;
    //         }


    //         let timePeriodInMonths = 0;

    //         if (SupplyAcquisitionTypeEnum[project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT) {
    //             timePeriodInMonths = project.requestedSupplyInfo.timePeriodInMonths && +project.requestedSupplyInfo.timePeriodInMonths;
    //         } else if (SupplyAcquisitionTypeEnum[project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.PURCHASE) {

    //             if (project.requestedSupplyInfo && project.requestedSupplyInfo.rolloutStart && project.requestedSupplyInfo.rolloutEnd) {
    //                 timePeriodInMonths = (project.requestedSupplyInfo.rolloutEnd.getTime() - project.requestedSupplyInfo.rolloutStart.getTime()) / 1000 / 60 / 60 / 24 / 30;
    //                 if (timePeriodInMonths < 0) {
    //                     timePeriodInMonths = 0;
    //                 }
    //                 timePeriodInMonths = Math.ceil(timePeriodInMonths);
    //                 if (debugLevel > 5) {
    //                     console.log('calculate timePeriodInMonths: ', timePeriodInMonths);
    //                 }
    //             } else {
    //                 if (debugLevel) {
    //                     console.log(supplyContainer.itemToOrder.sku + ' - some of supply info dates is not defined yet (rolloutStart/rolloutEnd): '
    //                         + project.requestedSupplyInfo.rolloutStart + '/' + project.requestedSupplyInfo.rolloutEnd);
    //                 }
    //                 return null;
    //             }

    //         }

    //         if (!Number.isFinite(timePeriodInMonths)) {
    //             if (debugLevel) {
    //                 console.log('timePeriodInMonths is not defined yet for  project.supplyAcquisitionType' + project.supplyAcquisitionType, timePeriodInMonths);
    //             }
    //             return null;
    //         }

    //         if (timePeriodInMonths < 1) {
    //             if (debugLevel) {
    //                 console.log('timePeriodInMonths is to low for project.supplyAcquisitionType ' + project.supplyAcquisitionType, timePeriodInMonths);
    //                 return -4;
    //             }
    //             return null;
    //         }
    //         const supplyRange = supplyContainer.itemToOrder.tonerInfo.range;


    //         if (!Number.isFinite(supplyRange) || supplyRange === 0) {
    //             console.warn('supply range is not defined or supplyRange = 0, amount cannot be calculated for sku:' + supplyContainer.itemToOrder.sku, supplyContainer);
    //             return 0;
    //         }
    //         const supplyRangeStarter = supplyContainer.itemToOrder.tonerInfo.rangeStarter;
    //         const hardwareCount = supplyContainer.parent.deviceAmount.amount;


    //         if ((printVolume * timePeriodInMonths) < supplyRangeStarter) {
    //             if (debugLevel) {
    //                 console.log(supplyContainer.parent.itemToOrder.sku + ' / ' + supplyContainer.itemToOrder.sku + ' - supplyRangeStarter enough to cover full required time period');
    //             }
    //             return 0;
    //         }

    //         // if (debug) {
    //         //     // console.log('going to calculate amount >>>>>>', (((printVolume * timePeriodInMonths) - supplyRangeStarter) / supplyRange) * hardwareCount);
    //         //     // console.log(' hardwareCount' + hardwareCount, supplyContainer.parent);
    //         //     // console.log('going to calculate amount', (((printVolume * timePeriodInMonths) - supplyRangeStarter) / supplyRange));
    //         //     // console.log('going to calculate amount', (((printVolume * timePeriodInMonths) - supplyRangeStarter)));
    //         //     // console.log('going to calculate amount', (((printVolume * timePeriodInMonths))));
    //         // }
    //         return Math.ceil((((printVolume * timePeriodInMonths) - supplyRangeStarter) / supplyRange) * hardwareCount);
    //     } catch (e) {
    //         console.warn('error occurred during recommended supply amount calculation: ', e.message);
    //         return 0;
    //     }
    // }


}
